import util from '@bmp-vue/core/api/util'

const controller = 'ParametrizacaoCedenteAgendaRecebiveis'

export default Object.assign({}, util.GetCrud(controller, ['none']), {
  BuscarCedentes: function (termo, pageSize = 10, page = 1) {
    return util.Axios.Get(controller + '/Limite/Duplicatas?DocumentoFederal=' + encodeURIComponent(termo) + '&PageSize=' + pageSize + '&Page=' + page)
  },
  GetDuplicataPorDocumento: function (documentoFederal, pageSize = 10, page = 1) {
    return util.Axios.Get(controller + '/Limite/Duplicatas?DocumentoFederal=' + encodeURIComponent(documentoFederal) + '&PageSize=' + pageSize + '&Page=' + page)
  },
  PostDuplicataLote: function (cedentes, options) {
    return util.Axios.Post(controller + '/Limite/Duplicata', cedentes, options)
  },
  PutDuplicataLote: function (cedentes, options) {
    return util.Axios.Put(controller + '/Limite/Duplicata', null, cedentes, options)
  },
  PersistDuplicataLote: function (cedentes, options) {
    const novos = cedentes.filter(c => !c.codigo)
    const existentes = cedentes.filter(c => c.codigo)

    const promises = []
    if (novos.length > 0) {
      promises.push(util.Axios.Post(controller + '/Limite/Duplicata', novos, options))
    }
    if (existentes.length > 0) {
      promises.push(util.Axios.Put(controller + '/Limite/Duplicata', null, existentes, options))
    }

    return Promise.all(promises)
  }
})
